import { GlobalDataContext } from "@/app/context/global/globalDataContext";
import MyCreatures from "@/app/layout/game/myCreatures";
import Header from "@/app/layout/global/header";
import { Button, ButtonGroup, Link, Text, useDisclosure } from "@chakra-ui/react";
import NextLink from "next/link";
import { useContext, useEffect, useMemo, useState } from "react";
import { FriendsContext } from "@/app/context/friends/friendsContext";
import { AuthenticationContext } from "@/app/context/authentication/authenticationContext";
import { GameFriendsScore } from "@/app/context/friends/layout/gameFriendsScore";
import { keyframes } from '@emotion/react';
import { GlobalDataUserContext } from "@/app/context/global/globalDataUserContext";
import Footer from "@/app/layout/global/footer";
import { buildChaseUrl } from "@/app/helpers/buildUrlHelper";
import { v4 } from "uuid";
import { useTranslation } from "next-i18next";
import MenuContent from "../global/menuContent";
import Skeleton from "../global/skeleton";
import { BodyHead } from "../global/bodyHead";
import { SwitchCreature } from "../game/modal/switchCreature";
import { CreatureDefinitionType } from "@/app/types/creatureDefinitionType";
import { SelectQuestDrawer } from "../game/modal/selectQuestDrawer";

const zoomAndShake = keyframes`
   0% {
    transform: scale(0) ;
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1) ;
    opacity: 1;
  }
  100% {
    transform: scale(1) ;
  }
`;


export default function CategoryLayout() {
    const { t } = useTranslation();
    const uuid = v4()
    const { isOpen:isOpenSwitch, onOpen:onOpenSwitch, onClose:onCloseSwitch } = useDisclosure();
    const {isOpen, onOpen, onClose} = useDisclosure()
    const {
        language,
        categoryId,
    } = useContext(GlobalDataContext)
    
    const {
        friendRequestWithUser,
    } = useContext(FriendsContext)
    
    const {
        user,
    } = useContext(AuthenticationContext)
    
    const {
        myCreatures,
        creatureToSwitch,
        closeSwitch
    } = useContext(GlobalDataUserContext)
    
    useEffect(()=>{
        if(creatureToSwitch){
            onOpenSwitch()
        }
    },[creatureToSwitch])

    const doCloseSwitch = () => {
        closeSwitch()
        onCloseSwitch()
    }

    const chaseUrl = useMemo(() => buildChaseUrl(language, categoryId, uuid), [language, categoryId, uuid]);

    return(
        <>
            <BodyHead
                url={process.env.NEXT_PUBLIC_URL as string}
                mainTitle={t("home.title")}
                title={t("home.titleBody")}
                description={t("home.descriptionBody")}
            />
            <Skeleton
                background={<MyCreatures shadow={true}/>}
                header={<Header title={t("menu.myGooblies")} /> }
                menu={<MenuContent/>}
                friends={<>{user && user.email && <GameFriendsScore friends={friendRequestWithUser}/> }</>}
                footer={<Footer>
                    <ButtonGroup margin="auto"variant='solid' size="lg" background="#6c27b7!important" borderRadius="50px" overflow={"hidden"}isAttached >
                        <Link margin={"auto"}href={chaseUrl} as={NextLink}> 
                            <Button margin="auto" borderRadius="0" background="#f16529!important" color="white!important"variant='solid' size="lg" >
                            {t("game.explore")}
                            </Button>
                        </Link>
                        <Button  onClick={onOpen} background="#6c27b7!important" className="pulse-yellow" color="white!important" >
                            {t("game.quest")}
                        </Button>
                    </ButtonGroup>
                    
                </Footer>}
            >
                <>
                    <Text px={5} pb={2} opacity={0.5} textAlign="right" size="sm" color="white">{myCreatures?.length} Gooblies</Text>
                    <MyCreatures/>
                    <SwitchCreature isOpen={isOpenSwitch} onClose={doCloseSwitch} originalCreature={creatureToSwitch} />
                    <SelectQuestDrawer isOpen={isOpen} onClose={onClose}/>
                </>
            </Skeleton>
            
        </>
    )

}